module.exports = __webpack_public_path__ + "assets/img/logo.c3be8c17.png";